module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/sendMoney/pickup-type/pickup-type.component.css
// module id = ./src/app/sendMoney/pickup-type/pickup-type.component.css
// module chunks = main